"use client";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useTranslations } from "next-intl";
import { useEffect } from "react";

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const route = useRouter();
  useEffect(() => {
    console.error(error);
  }, [error, route]);
  const t = useTranslations("Errors");

  return (
    <main className="-mt-20 flex min-h-screen w-full flex-1 items-center  bg-foregroundMuted pt-20">
      <section className="container flex flex-col-reverse  py-4 md:flex-col md:py-10">
        <article
          className={`flex flex-col-reverse justify-between gap-4 py-10 md:flex-row`}
        >
          <div className="flex aspect-video w-full flex-col justify-start sm:aspect-auto md:w-[calc(50%-20px)] md:max-w-[520px] md:justify-center">
            <h1 className="text-3xl font-bold tracking-tight md:text-4xl">
              {t("Title")}
            </h1>
            <p className="mt-5 text-primary-dark">{t("Description")}</p>
            <div className="mt-8 flex items-center">
              <Link
                className="inline-flex h-auto items-center justify-center gap-4 text-balance rounded-md bg-primary px-8  py-3 text-lg font-medium text-primary-foreground ring-offset-background transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:bg-inactive disabled:text-inactive-foreground"
                href="/"
              >
                {t("Action")}
              </Link>
            </div>
          </div>
          <div className="relative aspect-video w-full overflow-hidden rounded-xl md:aspect-square md:w-[calc(50%-20px)]">
            <Image
              className="fit-cover center h-full w-full"
              fill={true}
              alt=""
              role="presentation"
              src="/assets/error.png"
            />
          </div>
        </article>
      </section>
    </main>
  );
}
